module.exports = __webpack_public_path__ + "static/img/22.6b3e981.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/22.png
// module id = VHNN
// module chunks = 0